import {
  CUSTOM_RANGE_TYPE,
  LAST_DAYS_TYPE,
  LAST_MONTH_TYPE,
  TODAY_TYPE,
  YESTERDAY_TYPE,
} from 'Constants/FormElement';
import { TabPane } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';


export const DatePickerFilter = ({ activeCriteria, onDateChange }: any) => {
  const { id, type } = activeCriteria;
  let html = null;

  switch (type) {
    case TODAY_TYPE:
      html = <SingleCalendar date={new Date()} onDateChange={onDateChange} />;
      break;

    case YESTERDAY_TYPE:
      html = (
        <SingleCalendar
          date={new Date(Date.now() - 864e5)}
          onDateChange={onDateChange}
        />
      );
      break;

    case LAST_DAYS_TYPE:
      html = <Last7DaysCalendar onDateChange={onDateChange} />;
      break;

    case LAST_MONTH_TYPE:
      html = <LastMonthCalendar onDateChange={onDateChange} />;
      break;

    case CUSTOM_RANGE_TYPE:
      html = <CustomRangeCalendar onDateChange={onDateChange} />;
      break;
  }

  return <TabPane tabId={id}>{html}</TabPane>;
};

/* ===== Single Day ===== */
const SingleCalendar = ({ date, onDateChange }: any) => {
  const [selected, setSelected] = useState(date);

  useEffect(() => {
    onDateChange({ startDate: date, endDate: date });
  }, [date]);

  return (
    <DatePicker
      selected={selected}
      inline
      onChange={(d: any) => {
        setSelected(d);
        onDateChange({ startDate: d, endDate: d });
      }}
      formatWeekDay={(nameOfDay) => nameOfDay.substring(0, 3)}
    />
  );
};

/* ===== Custom Range ===== */
const CustomRangeCalendar = ({ onDateChange }: any) => {
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  useEffect(() => {
    onDateChange({ startDate, endDate });
  }, [startDate, endDate]);

  return (
    <div className="d-flex">
      <DatePicker
        selected={startDate}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        inline
        onChange={setStartDate}
      />
      <DatePicker
        selected={endDate}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        inline
        onChange={setEndDate}
      />
    </div>
  );
};

/* ===== Last 7 Days ===== */
const Last7DaysCalendar = ({ onDateChange }: any) => {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(endDate.getDate() - 6);

  useEffect(() => {
    onDateChange({ startDate, endDate });
  }, []);

  return (
    <div className="d-flex">
      <DatePicker selected={startDate} inline disabled />
      <DatePicker selected={endDate} inline disabled />
    </div>
  );
};

/* ===== Last Month ===== */
const LastMonthCalendar = ({ onDateChange }: any) => {
  const today = new Date();
  const startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const endDate = new Date(today.getFullYear(), today.getMonth(), 0);

  useEffect(() => {
    onDateChange({ startDate, endDate });
  }, []);

  return (
    <div className="d-flex">
      <DatePicker selected={startDate} inline disabled />
      <DatePicker selected={endDate} inline disabled />
    </div>
  );
};
